import axios from 'axios';

const baseDomain = process.env.BACKEND_HOST;
const baseURL = `${baseDomain}/backend`;

export const BackendRepository = axios.create({
  baseURL,
});
